<template >
  <div>
    <p class="control">
      <input id="file" class="inputfile" type="file" ref="fileinput" v-on:change="onselected" text="Select SVG Files" multiple placeholder="Email"/>
      <label class="button" for="file">
        <span class="icon"><i class="fa fa-plus-square"></i></span><span>Load SVG File(s)</span>
      </label>
    </p>

    <div class="columns is-multiline is-mobile">
    <div class="column is-3" v-for="f, i in pendingUploadFiles" >
      <div class="box content" v-if="f.file">
        
        <div v-if="!f.valid" class="notification is-danger">
          File {{ f.file.name }} is not valid
        </div>

        <table class="table" v-if="f.valid" >
          
          <tr>
            <td><label class="label has-text-right">Unique Name</label></td>
            <td v-if="assetUniqueNames.indexOf(f.unique_name) >= 0" class="control">
              <!-- <input type="text" class="input is-danger" @change="updateName(f, $event)" :value="f.unique_name" vv-model="f.unique_name" > -->
              <input type="text" class="input is-danger" @input="updateName(f, $event)" :value="f.unique_name" >
              <span class="help is-danger"><span class="icon is-small"><i class="fa fa-warning"></i></span> Name is in use already</span>
            </td>
            <td v-else class="control " >
              <!-- <input type="text" class="input" v-model="f.unique_name" > -->
              <input type="text" class="input" @input="updateName(f, $event)" :value="f.unique_name">
            </td>
          </tr>

          <tr>
            <td><label class="label has-text-right">File Name</label></td>
            <td>{{ f.file.name }}</td>
          </tr>
            
          <tr>
            <td><label class="label has-text-right">size</label></td>
            <td>{{ f.file.size }}</td>
          </tr>

          <tr>
            <td><label class="label has-text-right">last modified</label></td>
            <td><span v-if="f.file.lastModifiedDate">{{ f.file.lastModifiedDate.toLocaleTimeString() }} - {{ f.file.lastModifiedDate.toDateString() }}</span></td>
          </tr>
        </table>

        <div class="has-text-centered">
          <button class="button is-dark is-outlined" v-on:click="removePendingFile(f)">REMOVE</button>
        </div>

      </div>
    </div>
    </div>

    <p class="control" v-show="pendingUploadFiles.length > 0">
      <button class="button is-success" v-on:click="loadPendingFiles">
        Add Selected Resources
      </button>
    </p>
  </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "loadsvg",

  data: function() {
    return {
      tempNames: []
    };
  },

  computed: mapGetters({
    assetList: "assetList",
    validFileTypes: "validFileTypes",
    assetUniqueNames: "assetUniqueNames",
    pendingUploadFiles: "pendingUploadFiles",
  }),

  methods: {
    ...mapActions([
      "addPendingFile",
      "removePendingFile",
      "loadPendingFiles",
      "updatePendingFile"
    ]),

    updateName: function(file, event) {
      this.updatePendingFile({
        pendingFile: file,
        key: "unique_name",
        value: event.target.value
      });
    },

    onselected: function(e) {
      // load files into files_pending array
      // set valid flag based on type matching valid_file_types
      var files = this.$refs.fileinput.files;
      var id = Math.floor(new Date().valueOf() * Math.random());

      for (var key in files) {
        if (files.hasOwnProperty(key)) {
          var file = files[key];

          var f_temp = {
            valid: this.validFileTypes.indexOf(file.type) >= 0,
            selected: this.validFileTypes.indexOf(file.type) >= 0,
            id: "_" + id++,
            unique_name: file.name
              .split(".")
              .slice(0, -1)
              .join()
              .replace(/\_/gim, " "),
            file: file,
            data: ""
          };
          this.addPendingFile(f_temp);
        }
      }
      e.preventDefault();
    }
  }
};
</script>

<style lang="sass" scoped>
.button 
  margin: 5px 0 0
  &:active
    background-color: whitesmoke

.table td 
  vertical-align: middle

.control .button 
  margin: inherit

.inputfile 
  width: 0.1px
  height: 0.1px
  opacity: 0
  overflow: hidden
  position: absolute
  z-index: -1

</style>



// WEBPACK FOOTER //
// fileloader.vue?2c53465c